module.exports = __webpack_public_path__ + "static/lead-gen-fraud-ee4c665a99a1e058e7c53da7cb02fecf.gif";